import { useState } from 'react';

import { useGetFeatures, useViewFeatureReminderCommand } from '../hooks';

import { FEATURES } from '../constants';

import DiscountCodeReminder from '../components/DiscountCodeReminder';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FLAGS } from '../../common/constants/launchdarkly';
import AspectRatioReminder from '../components/AspectRatioReminder';
import TermsUpdateReminder from '../components/TermsUpdateReminder';

const NO_OF_TIMES_TO_SHOW_FEATURE_REMINDER = 2;

interface UseFeatureReminderModalParams {
  screenName: string;
  featureName?: string;
  noOfTimesToShowFeatureReminder?: number;
}

const useFeatureReminderModal = ({
  featureName,
  screenName,
  noOfTimesToShowFeatureReminder = NO_OF_TIMES_TO_SHOW_FEATURE_REMINDER
}: UseFeatureReminderModalParams) => {
  const flags = useFlags();
  const [showFeatureReminder, setShowFeatureReminder] = useState(true);

  const closeFeatureReminderModal = () => {
    setShowFeatureReminder(false);
  };

  const { data: features } = useGetFeatures();
  const { mutate: viewFeatureReminder } = useViewFeatureReminderCommand();

  const showFeatureReminderModal = () => {
    if (!flags[FLAGS.ENABLE_FEATURE_REMINDERS]) {
      return null;
    }

    for (let i = 0; i < features?.items.length; i++) {
      const feature = features.items[i];
      const screenViews = feature.reminder?.views[screenName];

      if (featureName && feature.name !== featureName) {
        return null;
      }

      if (!screenViews || screenViews < noOfTimesToShowFeatureReminder) {
        switch (feature.name) {
          case FEATURES.DISCOUNT_CODES:
            return (
              <DiscountCodeReminder
                isVisible={showFeatureReminder}
                onPressContinue={() => {
                  viewFeatureReminder({
                    featureId: feature.id,
                    screenName
                  });

                  closeFeatureReminderModal();
                }}
              />
            );

          case FEATURES.EVENT_ASPECT_RATIO:
            return (
              <AspectRatioReminder
                isVisible={showFeatureReminder}
                onPressContinue={() => {
                  viewFeatureReminder({
                    featureId: feature.id,
                    screenName
                  });

                  closeFeatureReminderModal();
                }}
              />
            );

          case FEATURES.TERMS_UPDATE:
            return (
              <TermsUpdateReminder
                isVisible={showFeatureReminder}
                onPressContinue={() => {
                  viewFeatureReminder({
                    featureId: feature.id,
                    screenName
                  });

                  closeFeatureReminderModal();
                }}
              />
            );
        }
      }
    }

    return null;
  };

  return {
    showFeatureReminderModal
  };
};

export default useFeatureReminderModal;
